import { useRef } from "react";
import { useFirstMountState } from "react-use";

export function usePrevious<T>(data: T, isLoading: boolean) {
  const currentRef = useRef<T>(data);
  const isFirstMount = useFirstMountState();
  if (!isFirstMount && !isLoading) {
    currentRef.current = data;
  }
  return currentRef.current;
}
